module.exports = __webpack_public_path__ + "static/media/FromLittleTokyoWithLove.072002bc.jpg";